import * as React from "react"
import { Box, Typography } from "@mui/material"

import { ManagementPricingConfigPendingChip } from "../../@components"


/** The main site of that market: the price every retailer of the market is compared against. */
export default function siteColumn() {
    return {
        name: 'siteName', label: 'Main site',
        options: {
            headerAlign: 'center',
            setCellProps: () => ({ sx: { textAlign: "center" } }),
            customBodyRowRenderLite: (value, row) => <Box
                display="flex" justifyContent="center" alignItems="center"
            >
                {value}
                <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                    #{row.siteID}
                </Typography>
                <ManagementPricingConfigPendingChip pending={row.pending} />
            </Box>
        }
    }
}
